import React from "react";
import { useNavigate } from "react-router-dom";
import "./ListItem.css";
import { BsTelephone, BsInstagram } from "react-icons/bs";
import { FaLinkedinIn, FaFacebookF } from "react-icons/fa";
import { FiMail } from "react-icons/fi";

const ListItem = ({ data }) => {
    const navigate = useNavigate();
    const { title, children } = data;

    return (
        <React.Fragment>
            <nav>
                <div className="item-title">{title}</div>
                <ul className="list-unstyled">
                    {title === "ABOUT DSSL" &&
                        children.map((item, index) => (
                            <li className="item-children" key={index}>
                                {item === "Our Store" && (
                                    <a
                                        key={index}
                                        href="#story"
                                        onClick={() => navigate("/learn")}
                                    >
                                        {item}
                                    </a>
                                )}
                                {item === "Our Reps" && (
                                    <a
                                        key={index}
                                        href="#about-header"
                                        onClick={() => navigate("/learn")}
                                    >
                                        {item}
                                    </a>
                                )}
                                {item === "Contact Us" && (
                                    <a
                                        key={index}
                                        href="#contact-us"
                                        onClick={() => navigate("/learn")}
                                    >
                                        {item}
                                    </a>
                                )}
                            </li>
                        ))}
                    {title === "RESOURCES" &&
                        children.map((item, index) => (
                            <li className="item-children" key={index}>
                                {item === "All Downloads" && (
                                    <a
                                        key={index}
                                        onClick={() => navigate("/resources")}
                                    >
                                        {item}
                                    </a>
                                )}
                                {item === "Case Studies" && (
                                    <a
                                        key={index}
                                        onClick={() => navigate("/case-study")}
                                    >
                                        {item}
                                    </a>
                                )}
                                {item === "Warranties / Terms & Conditions" && (
                                    <a
                                        key={index}
                                        onClick={() =>
                                            navigate("/warranty-docs")
                                        }
                                    >
                                        {item}
                                    </a>
                                )}
                            </li>
                        ))}
                    {title === "GET IN TOUCH" &&
                        children.map((item, index) => (
                            <li className="item-children" key={index}>
                                {item.icon === "phone" && (
                                    <a>
                                        <BsTelephone
                                            style={{ marginRight: "20px" }}
                                        />
                                        {item.content}
                                    </a>
                                )}
                                {item.icon === "email" && (
                                    <a>
                                        <FiMail
                                            style={{ marginRight: "20px" }}
                                        />
                                        {item.content}
                                    </a>
                                )}
                                {item.icon === "instagram" && (
                                    <a>
                                        <BsInstagram
                                            style={{ marginRight: "20px" }}
                                        />
                                        {item.content}
                                    </a>
                                )}
                                {item.icon === "facebook" && (
                                    <a
                                        href="https://www.facebook.com/DSSLLighitng/"
                                        target="_blank"
                                    >
                                        <FaFacebookF
                                            style={{ marginRight: "20px" }}
                                        />
                                        {item.content}
                                    </a>
                                )}
                                {item.icon === "linkedin" && (
                                    <a
                                        href="https://www.linkedin.com/company/dssl-lighting"
                                        target="_blank"
                                    >
                                        <FaLinkedinIn
                                            style={{ marginRight: "20px" }}
                                        />
                                        {item.content}
                                    </a>
                                )}
                            </li>
                        ))}
                    {title === "PRODUCTS" &&
                        children.map((item, index) => (
                            <li className="item-children" key={index}>
                                <a
                                    key={index}
                                    onClick={() =>
                                        navigate(
                                            `/products/category/${item.attributes.name}`
                                        )
                                    }
                                >
                                    {item.attributes.name}
                                </a>
                            </li>
                        ))}
                </ul>
            </nav>
        </React.Fragment>
    );
};

export default ListItem;
